import React from 'react'
import AudioInput from '@/components/inputs/AudioInput'
import { mergeEntityData } from '../../utils/mergeEntityData'
import AtomicBlockShell from '../AtomicBlockShell'

export const RTEAudioInput = ({
    id,
    value,
    files,
    readOnlyProp, 
    setReadOnly, 
    editorState, 
    handleChange,
    entityKey, 
    block,
    isInRTE 
}) => {
  
  
  return (
    <>
    { (files || value) && 
    <AtomicBlockShell {...{ 
      id, 
      readOnlyProp, 
      setReadOnly, 
      editorState, 
      handleChange, 
      block,
      actions: [
      
      { icon: "UploadSimple",
        display: "Replace Audio",
        onClick: () => {
          const actualReuploadButton = document.getElementById('reuploadAudio');
          actualReuploadButton.click()
        }
      },
      ] 
      }}>
        <AudioInput 
          value={value}
          files={files}
          onChange={(id, v) => {
            mergeEntityData(
              editorState,
              handleChange,
              entityKey,
              { value: v, files: undefined }
              );
            }}
          readOnly={readOnlyProp}
          isInRTE={isInRTE}
          />
   </AtomicBlockShell>
    }
   </>
  )
}
